{
  "common": {
    "other": "-- Autres --",
    "customFieldExistsError": "Champ personnalisé avec ce nom existe déjà",
    "uniqueKeyNotUniqueError": "Cette clé n'est pas unique",
    "save": "Sauvegarder",
    "saving": "Sauvegarde en cours",
    "typeAnOption": "Saisissez une option",
    "unsaved": "Non enregistré",
    "noSubmissionsFound": "Aucune soumission trouvée",
    "sortBy": "Trier par",
    "clearAll": "Tout effacer",
    "clear": "Effacer",
    "submitSurvey": "Soumettre le sondage",
    "select": "Sélectionner",
    "disqualifyImmediately": "Disqualifier immédiatement",
    "disqualifyAfterSubmit": "Disqualifier après soumission",
    "disqualifyAfterSubmitLower": "Disqualifier après soumission",
    "errorRetryAgain": "Erreur, réessayez",
    "recurringFrequency": {
      "once": "Une fois",
      "daily": "Quotidiennement",
      "weekly": "Hebdomadaire",
      "monthly": "Mensuel",
      "yearly": "Annuel"
    },
    "yes": "Oui",
    "no": "Non",
    "updated": "Mis à jour",
    "new": "Nouveau",
    "title": "Titre",
    "description": "Description",
    "cannotAddThisField": "Vous ne pouvez pas ajouter ce champ",
    "overallOnly": "Globalement seulement",
    "nextSlideDefault": "Diapositive suivante (par défaut)",
    "nextQuestion": "Question suivante",
    "searchAddress": "Recherchez une adresse",
    "recurringDonation": "Don récurrent",
    "recurringDonationDay": "Don récurrent d'une journée",
    "recurringDonationWeek": "Don récurrent hebdomadaire",
    "recurringDonationMonth": "Don récurrent d'un mois",
    "recurringDonationYear": "Don récurrent d'un an",
    "integrate": "Intégrer",
    "preview": "Aperçu",
    "back": "Retour",
    "alert": "Alerte",
    "proceed": "Poursuivre",
    "confirm": "Confirme",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "embed": "Intégrer",
    "link": "Lien",
    "linkModal": {
      "title": "Insérer un lien",
      "urlLabel": "URL",
      "urlPlaceholder": "https://www.example.com",
      "invalidUrl": "URL non valide"
    },
    "iframeEmbed": "Intégration Iframe",
    "styles": "Styles",
    "options": "Options",
    "quickAdd": "Ajout rapide",
    "customFields": "Champs personnalisés",
    "addObjectFields": "Ajouter des Domaines d'Objet",
    "personalInfo": "Information personnelle",
    "contactInfo": "Coordonnées",
    "submit": "Soumettre",
    "address": "Adresse",
    "customized": "Sur mesure",
    "layout": "Mise en page",
    "showLabel": "Afficher l’étiquette",
    "background": "Arrière-plan",
    "buttonBackground": "Contexte du Bouton",
    "fontColour": "Couleur de la Police",
    "textFontColour": "Couleur de la police du texte",
    "subTextFontColour": "Couleur de la police du sous-texte",
    "selectThemes": "Sélectionner un thème",
    "selectOne": "Sélectionnez une option",
    "enableIcon": "Activer l'icône",
    "iconType": "Type d'icône",
    "iconPlacement": "Placement des Icônes",
    "filled": "Rempli",
    "textOnly": "Corps uniquement",
    "border": "Bordure",
    "borderType": "Type de bordure",
    "cornerRadius": "Rayon de l'angle",
    "width": "Largeur",
    "padding": "Remplissage",
    "top": "Haut",
    "bottom": "Bas",
    "left": "Gauche",
    "right": "Droite",
    "center": "Centre",
    "default": "Par défaut",
    "formDefault": "Formulaire par défaut",
    "shadow": "Ombre",
    "color": "Couleur",
    "horizontal": "Horizontal",
    "vertical": "Vertical",
    "blur": "Flou",
    "spread": "Diffusion",
    "fieldStyle": "Style de champ",
    "fontColor": "Couleur de la police",
    "inputTextFillColor": "Couleur de remplissage du texte de la zone de saisie",
    "inputTextColor": "Couleur du texte de la zone de saisie",
    "primaryColor": "Couleur primaire",
    "primaryColorTooltip": "Contrôle la couleur pour l’état de survol et l’état actif.",
    "inputTextColorTooltip": "Contrôle la couleur du texte saisi dans les champs.",
    "mapPrimaryColorToButtonColor": "Associer la couleur primaire à la couleur du bouton",
    "label": "Étiquette",
    "fontFamily": "Famille de polices",
    "size": "Taille",
    "weight": "Poids",
    "fontWeightOptions": {
      "thin": "100 - Mince",
      "extraLight": "200 - Très clair",
      "light": "300 - Clair",
      "normal": "400 - Normal",
      "medium": "500 - Moyen",
      "semiBold": "600 - Semi-gras",
      "bold": "700 - Gras"
    },
    "placeholder": "Espace réservé",
    "customCSS": "CSS personnalisé",
    "backgroundImage": "Image d’arrière-plan",
    "headerImage": "Image d'en-tête",
    "miscellaneous": "Divers",
    "agencyBranding": "Image de marque de l’agence",
    "imageUploadMessage": "Cliquez ou faites glisser un fichier vers cette zone pour le téléverser.",
    "backgroundImageTooltipMessage": "L'image d'arrière-plan est destinée à couvrir toute la page, offrant ainsi une toile de fond visuellement attrayante pour le formulaire. Pour afficher l’image d’arrière-plan, cliquez sur l’option Aperçu.",
    "headerImageTooltipMessage": "L’image d’en-tête est conçue pour couvrir toute la largeur du formulaire et reste positionnée en haut du formulaire. Pour afficher l'image d'en-tête, cliquez sur l'option Aperçu.",
    "onSubmit": "Lors de la soumission",
    "facebookPixelID": "Identifiant de pixel Facebook",
    "facebookPixelIDMessage": "Ignorez ce champ si vous prévoyez d'utiliser ce formulaire/cette enquête dans un entonnoir.",
    "facebookPixelEvents": "Événements du pixel Facebook",
    "onpageView": "Affichage sur la page",
    "stickyContact": "Contact collant",
    "stickyContactMessage": "Mémorise et remplit automatiquement les coordonnées lorsque l'utilisateur revient sur le même appareil et le même navigateur.",
    "fieldDescription": "Description du champ",
    "fieldTitle": "Titre du champ",
    "queryKey": "Clé de requête",
    "querykeyTooltipMessage": "La clé de requête peut être utilisée comme paramètre URL pour remplir ce champ.",
    "required": "Obligatoire",
    "hidden": "Caché",
    "hiddenValue": "Valeur cachée",
    "enableCountryPicker": "Activer le sélecteur de pays",
    "altText": "Texte de remplacement",
    "alignment": "Alignement",
    "imageWidth": "Largeur de l’image",
    "imageHeight": "Hauteur de l'image",
    "logic": "Logique",
    "pleaseInput": "Veuillez saisir",
    "editHTML": "Modifier l'HTML",
    "textStyle": "Style du texte",
    "subText": "Sous-texte",
    "text": "Texte",
    "buttonStyle": "Style du bouton",
    "fullWidth": "Pleine largeur",
    "htmlMessage": "Placez le code HTML personnalisé ici.",
    "htmlEditorHeader": "JAVASCRIPT / HTML PERSONNALISÉ",
    "htmlEditorBodyMessage": "Ajoutez votre code ici.",
    "yesSave": "Oui, sauvegarder",
    "cancelKeep": "Annuler, conserver",
    "done": "Terminé",
    "addElement": "Ajouter un élément",
    "addUrlLike": "Ajoutez des URL valides comme",
    "doNotAddRelativePath": "N'ajoutez pas de chemins relatifs comme",
    "or": "ou",
    "addCustomFields": "Ajouter des champs personnalisés",
    "customFieldSearch": "Recherche par nom",
    "enterSourceValue": "Saisis la valeur source",
    "shortLabel": "Étiquette courte",
    "shortLabelPlaceholder": "Police",
    "labelPlaceholder": "Type une étiquette",
    "fileUploadPlaceholder": "Téléverser un fichier",
    "customCSSTooltip": "La feuille de style personnalisée a préséance sur le style de forme et les thèmes et peut avoir un impact sur le style du thème.",
    "fontFamilyTooltip": "Le générateur prend en charge tous les types de polices si vous ne les voyez pas dans la liste. Veuillez la rechercher dans le menu déroulant.",
    "useGDPRCompliantFont": "Utilisez une police conforme au RGPD.",
    "enableTimezone": "Activer le fuseau horaire",
    "inputStyle": "Style d’entrée",
    "conditionalLogicAlertOnSubmit": "La logique conditionnelle aura préséance sur le message / rediriger ici.",
    "conditionalLogicAlertOnShowHide": "La logique conditionnelle aura préséance sur les paramètres cachés ici.",
    "placeholderFacebookPixelIdInput": "Saisir l'identifiant de pixel Facebook",
    "doNotShowMessage": "Ne plus afficher",
    "creatingForm": "OK",
    "creatingSurvey": "Créez votre Sondage...",
    "creatingQuiz": "Créez votre quiz...",
    "errorCreatingForm": "Une erreur s'est produite lors de votre formulaire. Veuillez réessayer.",
    "errorCreatingSurvey": "Là a été une erreur Veuillez réessayer.",
    "errorCreatingQuiz": "Une erreur s'est produite lors de la création de votre quiz. Veuillez réessayer.",
    "redirectMessage": "Vous serez redirigé vers :",
    "themes": {
      "themes": "Thèmes",
      "alertThemeMessage": "Le changement de thème entraîne la perte de toutes les modifications de style en cours.",
      "useTheme": "Utiliser le thème",
      "removeTheme": "Supprimer le thème"
    },
    "box": "Case",
    "line": "Ligne",
    "message": "Message",
    "openUrl": "Ouvrir l'URL",
    "borderTypeList": {
      "dotted": "Pointillés",
      "dashed": "Tiretés",
      "solid": "Ligne continue",
      "none": "Aucun"
    },
    "button": "Bouton",
    "emailNotification": "Notification par courriel",
    "emailNotificationSubheader": "Recevoir un courriel lorsque quelqu'un remplit votre formulaire",
    "subject": "Objet",
    "emailTo": "Courriel (À)",
    "senderName": "Nom de l’expéditeur",
    "senderNameWarning": "Votre (nom de sous-compte) sera ajouté si ce champ est laissé vide.",
    "emailError": "Au moins une adresse courriel est obligatoire",
    "emailTooltip": "La première adresse courriel est désignée pour le champ « À ». Toutes les adresses courriel ultérieures seront incluses dans le champ « Cc ».",
    "clear": "Effacer",
    "filter": "Filtre",
    "noResults": "Aucun résultat",
    "search": "Rechercher",
    "showNotificationsSettings": "Afficher les paramètres des notifications",
    "emailServicePaid": "Cette fonctionnalité est un service payant et entraînera des frais en fonction de votre utilisation.",
    "integration": "Intégration",
    "validation": {
      "fieldRequired": "Champ est obligatoire",
      "maxLengthExceeded": "Max' accord ({max}"
    },
    "products": {
      "subscriptionBadge": "Abonnement",
      "trialBadge": "{days} jours d'essai gratuit",
      "setupFee": "Frais d’installation uniques",
      "quantity": "Quantité",
      "productImageAlt": "Image du produit",
      "bumpIconAlt": "Icône complémentaire"
    },
    "payment": {
      "payments": "Paiements",
      "connected": "Connecté",
      "connect": "Se connecter",
      "liveModeOn": "Mode en direct",
      "status": "Statut",
      "test": "Essai",
      "live": "En direct",
      "paymentFields": "Champs de paiement",
      "suggestAnAmount": "Proposer un montant",
      "recurringPayments": "Paiements Récurrents",
      "selectCurrency": "Sélectionner la devise",
      "tagActiveBGColor": "Couleur de l'étiquette active",
      "includeOtherAmount": "Inclure l'autre montant",
      "footerInfo": "Informations de pied de page",
      "paymentType": "Type de paiement",
      "sellProducts": "Vendre des produits",
      "customAmount": "Montant personnalisé",
      "collectPayment": "Percevoir le paiement",
      "generalSettings": "Champs généraux",
      "securePayments": "* 100 %.",
      "error": {
        "addMainProductFirst": "Ajoutez un produit PRIMAIRE en premier",
        "priceNotFoundForBumpProduct": "Prix trouvé pour le Produit à bosses",
        "productAlreadyAdded": "Produit déjà ajouté"
      },
      "product": {
        "addProduct": "Ajouter un produit",
        "productSettings": "Paramètres du produit",
        "bumpTag": "Complémentaire",
        "settingsAria": "Paramètres du produit",
        "deleteAria": "Supprimer le produit",
        "selectProduct": "Sélectionner un produit",
        "editThisProduct": "Pour modifier ce produit",
        "clickHere": "Cliquez ici",
        "show": "Afficher",
        "description": "Description",
        "image": "Image",
        "layoutSettings": "Paramètres de mise en page",
        "singleColumn": "Colonne unique",
        "twoColumn": "Deux colonnes",
        "threeColumn": "Trois colonnes",
        "maxProductError": "Nombre maximal de 20 produits autorisés dans un formulaire",
        "productSelectPlaceholder": "Veuillez sélectionner un produit.",
        "orderConfirmation": "Confirmation de commande",
        "orderConfirmationWarning": "Une page de confirmation de commande s'affichera une fois le paiement effectué.",
        "quantity": "Quantité",
        "createProduct": "Pour créer un produit",
        "noProductsAdded": "Aucun produit ajouté pour le moment",
        "productsWillShowHere": "Une fois que vous avez inclus des produits, ils s'afficheront ici",
        "chooseProductType": "Sélectionner Typede produit",
        "mainProduct": "PRIMAIRE"
      },
      "bumProduct": {
        "price": "Prix",
        "variant": "Variante",
        "headline": "Titre",
        "otoHeadline": "OTO Titre",
        "otoText": "OK",
        "enableImage": "Activer Image",
        "imageMessage": "Nous saisirons l' Image par défaut",
        "orUploadADifferentImage": "Téléverser une autre Image",
        "bumpProducts": "Produits à bosses",
        "bumpProduct": "Produit à bosses",
        "enableBump": "Activer le bosse",
        "orderBumpStyle": "Personnaliser le Style",
        "classic": "Classique",
        "modern": "Aujourd'hui",
        "icon": "Icône",
        "bumpTemplate": "Sélectionner un Modèle",
        "highlightText": "Mise en page du corps",
        "showPrice": "Afficher le Prix",
        "bumpPriceColor": "Prix à bosses",
        "bumpIconColor": "Icône à bosses",
        "bumpBackgroundColor": "Contexte de la bosse",
        "highlightTextColor": "Mise en page du corps",
        "headlineColor": "Titre",
        "otoHeadlineColor": "OTO Titre",
        "otoTextColor": "OK",
        "bumpBorderColor": "Bordure de la bosse",
        "priceRequired": "Le prix est obligatoire",
        "headlineRequired": "Le titre est obligatoire",
        "otoHeadlineRequired": "Le titre de l’OTO est obligatoire",
        "otoTextRequired": "Le texte OTO est requis",
        "bumpProductTooltip": "Une . Les clients peuvent l'inclure avec un .",
        "templateOne": "Modèle 1",
        "templateTwo": "Modèle 2",
        "templateThree": "Modèle 3",
        "animationIcon": {
          "none": "Aucun",
          "arrow": "Flèche",
          "fire": "Incendre",
          "plus": "Plus",
          "giftBox": "Boîte à cocher",
          "timer": "Compte à rebours",
          "cracker": "Catégorisation",
          "snack": "Collant",
          "partyBalloon": "Groupe de danse",
          "flash": "Instantané",
          "money": "Monnaie",
          "spaceShuttle": "Transfert de Espace"
        }
      },
      "coupons": {
        "coupons": "Coupons",
        "enableCoupon": "Activer le coupon",
        "couponAlignment": "Alignement des coupons",
        "left": "Gauche",
        "right": "Droite",
        "fullWidth": "Pleine largeur",
        "tooltipMessage": "Définir la position de l'entrée du coupon à partir des types ci-dessous"
      }
    },
    "addressSettings": {
      "autoComplete": "Remplissage automatique de l'adresse",
      "addressfields": "Champs d'adresse",
      "placeholderSearch": "Rechercher une adresse",
      "autoCompleteTooltip" : "Permet de rechercher et de renseigner automatiquement l'adresse. Cette fonctionnalité est facturable.",      "streetAddress": "Adresse de la rue",
      "autoCompleteAddressTitle": "Finir Auto l'adresse",
      "newBadge": "Nouveau",
      "defaultLabel": "Adresse",
      "searchPlaceholder": "Rechercher des adresses",
      "mandataorySearch": {
        "title": "Obligatoire pour l'adresse in la barre de recherche",
        "primaryText": "Remplissage automatique uniquement pour Adresse de la rue",
        "secondaryText": "Quand il est activé, lorsqu'un utilisateur interagir avec le champ d'adresse, Ensuite, ils doivent comporter une adresse valide pour continuer.",
        "secondaryText1": "in"
      }
    },
    "autoResponder": "Répondeur automatique",
    "autoResponderSubheader": "Envoyez un courriel automatique à la personne qui soumet le formulaire (le courriel comprend une copie des renseignements saisis dans le formulaire).",
    "replyToEmail": "Réponse au courriel",
    "open": "Ouvert",
    "won": "Réussi",
    "lost": "Perdu",
    "abandon": "Abandonner",
    "selectAPipeline": "Sélectionner un pipeline",
    "stage": "Étape",
    "status": "Statut",
    "opportunityValue": "Valeur de l’opportunité",
    "createNewPipeline": "Créer un nouveau pipeline",
    "editOpportunitySettings": "Modifier les paramètres de l'opportunité",
    "contact": "Contact",
    "opportunity": "Opportunité",
    "business": "Entreprise",
    "add": "Ajouter",
    "more": "Plus",
    "opportunityHeading": "Où voulez-vous que votre opportunité soit mise à jour?",
    "date": {
      "dateSettings": "Paramètres de date",
      "dateFormat": "Format de la date",
      "dateSeparator": "Séparateur de date",
      "dateFormatTooltipMessage": "Sélectionnez un format de date. D représente le jour, M les mois et Y l'année",
      "dateSeparatorTooltipMessage": "Sélectionnez un séparateur qui séparera le jour, le mois et l'année dans le format sélectionné dans Format de la date.",
      "disablePicker": "Désactiver le sélecteur"
    },
    "restoreVersion": "Restaurer la version",
    "versionHistory": "Historique de la version",
    "errorMessage": "Erreur, réessayez",
    "version": "Version :",
    "currentVersion": "Version actuelle",
    "messageStyling": "Style du message",
    "validateEmailHeader": "Valider le courriel",
    "validateEmailDescription": "Le bouton sera visible une fois que l'utilisateur aura saisi son courriel. Cette fonctionnalité est conçue pour vous aider à générer des prospects de qualité.",
    "validatePhoneHeader": "Valider le numéro de téléphone",
    "validatePhoneDescription": "Le bouton sera visible une fois que l'utilisateur aura saisi son numéro de téléphone. Cette fonctionnalité est conçue pour vous aider à générer des prospects de qualité.",
    "validatePhoneWarning": "Pour activer la vérification par mot de passe unique reçu par SMS, assurez-vous que votre numéro de téléphone est configuré dans tes paramètres de localisation.",
    "addAnotherTnc": "Ajouter d'autres conditions générales",
    "tnc1": "T & C 1",
    "tnc2": "Conditions générales 2",
    "deleteCaps": "SUPPRIMER",
    "deleteConfirmation": "Tapez SUPPRIMER pour confirmer",
    "style": {
      "formLayoutType": "Type de formulaire",
      "layoutType": "Type de mise en page",
      "surveyType": "Type de sondage",
      "oneColumn": "Une colonne",
      "twoColumn": "Deux colonnes",
      "singleLine": "Ligne unique",
      "fieldWidth": "Largeur du champ",
      "labelAlignment": {
        "labelAlignment": "Alignement des étiquettes",
        "labelWidth": "Largeur de l'étiquette"
      },
      "fieldSpacing": "Espacement des champs",
      "color": "couleur",
      "fontColor": "Couleur de la police",
      "inputBackgroundColor": "Couleur d'arrière-plan de la zone de saisie",
      "inputBorder": "Bordure de la zone de saisie",
      "layout": "Mise en page",
      "colorsAndBackground": "Couleurs et arrière-plan",
      "advanceSettings": "Réglages avancés",
      "inputField": "Champ de saisie",
      "borderWidth": "Largeur de la bordure",
      "borderColor": "Couleur de bordure",
      "borderStyle": "Style de bordure",
      "fontSize": "Taille de la police",
      "fontWeight": "Poids de la police",
      "labelColor": "Couleur de l’étiquette",
      "placeholderColor": "Couleur de l'espace réservé",
      "shortLabelColor": "Couleur de l’étiquette courte"
    },
    "replyToTooltip": "Personnalisez l'adresse courriel de réponse par défaut en utilisant {'{'}{'{'}contact.email{'}'}{'}'} pour permettre de répondre au contact qui soumet le formulaire.",
    "content": "Contenu",
    "calculations": "Calculs",
    "uploadOptions": "Options de téléversement",
    "opportunitySettingsWarning": "Veuillez configurer les paramètres d’opportunité en cliquant sur le bouton Modifier les paramètres d’opportunité.",
    "startValue": "Valeur de début",
    "endValue": "Valeur finale",
    "today": "Aujourd'hui",
    "thisWeek": "Cette semaine",
    "last7Days": "Les 7 derniers jours",
    "thisMonth": "Mois en cours",
    "last30Days": "Les 30 derniers jours",
    "question": "Question",
    "createContactOnPartialSubmission": "Créer un contact lors de la soumission partielle",
    "howItWorks": "Comment ça fonctionne?",
    "createContactOnPartialSubmissionDescription": "Terminez la diapositive et cliquez sur « Suivant ». Un nouveau contact sera automatiquement créé et enregistré.",
    "swapWarningMessageSurvey": "La modification ou le changement d'options aura un impact sur ce champ personnalisé partout où le champ est utilisé. Cela peut également réinitialiser la logique conditionnelle. ",
    "swapWarningMessageForm": "La modification ou le changement d'options aura un impact sur ce champ personnalisé partout où le champ est utilisé. ",
    "migrationWarningMessage": "Cette fonctionnalité a été migrée vers la logique conditionnelle d’enquête.",
    "optionLabel": "Étiquette d'option",
    "calculationValue": "Valeur de calcul",
    "addOption": "Ajouter une option",
    "enableCalculations": "Activer les calculs",
    "allowOtherOption": "Autoriser une autre option",
    "productSelectionSubtext": "Individuel sur la sélection de plusieurs produits",
    "multi": "Plusieurs",
    "single": "Individuel",
    "productSelectionHeading": "Sélection du Produit",
    "spreadToColumns": "Diffusion aux colonnes",
    "columns": "Colonnes",
    "customstyle": "Style",
    "standard": "Norme",
    "bubble": "Bulle",
    "integratePopup": {
      "title": "Intégrer le formulaire",
      "embedCode": "Code d'intégration",
      "useInFunnelOrEmbedCode": "Utilisation dans l'entonnoir / Code d'intégration",
      "iframeEmbed": "Embarquer Iframe",
      "layout": {
        "title": "Intégrer le type de mise en page",
        "description": "Sélectionnez une mise en page à intégrer dans un entonnoir ou un site Web externe",
        "allowMinimize": "Permettre de minimiser",
        "minimizedTitlePlaceholder": "Titre minimisé",
        "leftAlignAlt": "Aligner à gauche",
        "rightAlignAlt": "Alignement à droite"
      },
      "triggerType": "Type de déclencheur",
      "triggers": {
        "seconds": "secondes"
      },
      "activation": {
        "title": "Options d'activation",
        "visit": "visiter"
      },
      "deactivation": {
        "title": "Options de désactivation",
        "times": "fois"
      },
      "copyEmbedCode": "Copier le code d'intégration",
      "copyFormLink": "Copier le lien du formulaire",
      "openFormLink": "Lien pour le formulaire ouvert",
      "invalidInput": "Entrée non valide!",
      "funnel": {
        "funnel": "Entonnoir",
        "chooseStep": "Sélectionner une étape",
        "copyCodeAndOpenFunnel": "Copie le Code et Ouvert Entonnoir"
      },
      "share": {
        "share": "Partager",
        "shareViaSocials": "Partager via les Réseaux sociaux",
        "copyLink": "Copier le lien"
      },
      "email": {
        "email": "Courriel",
        "shareViaEmail": "Partager via Courriel",
        "emailButton": "Courriel",
        "blankTemplate": "Format d' Modèle",
        "emailMarketingTemplates": "Modèles de Marketing par Courriel",
        "or": "Ou",
        "chooseTemplate": "Sélectionnez parmi vos modèles",
        "continue": "Continuer"
      }
    },
    "rating": {
      "icon": "Icône",
      "iconAlignment": "Alignement des Icône",
      "count": "Nombre",
      "lowestRating": "Évaluation Min",
      "highestRating": "Évaluation Max",
      "iconSelectedState": "Icône État Sélectionné",
      "iconUnselectedState": "Icône de État non sélectionné",
      "rating": "Évaluation",
      "ratingSettings": "Réglages Évaluation",
      "calculationType": {
        "calculationType": "Comment Évaluation les domaines in des domaines personnalisés",
        "calculationTypeTooltip": "Quand vous enregistrez un message",
        "absolute": "Total",
        "percentage": "Pourcentage",
        "fraction": "Fraction"
      }
    },
    "desktopMode": "Mode bureau",
    "mobileMode": "Mode mobile",
    "versions": "Variantes",
    "advanced": "Avancé",
    "edit": "Modifier",
    "settings": "Réglages",
    "submissions": "Soumissions",
    "undo": "Annuler",
    "redo": "Refaire",
    "customValues" : "Valeurs personnalisées",
    "pickBgFromImage" : "Sélectionnez une couleur de fond à partir de l'image d'arrière-plan du formulaire.",
    "pickBgFromImageTip" : "Choisit une couleur à contraste élevé pour l'image d'arrière-plan. Remarque : ne s'applique pas si l'arrière-plan du formulaire ne comporte pas d'image.",
    "messageBackgroundBlur" : "Arrière-plan de message flouté",
    "confirmationMessage": "Message de confirmation",
    "deleteOption": "Supprimer l’option",
    "deleteConfirmationModal": {
      "defaultDescription": "Supprimer une option aura un impact sur ce Champ Voulez-vous vraiment le supprimer?",
      "validationMessage": "Veuillez saisir pour enregistrer.",
      "validationError": "Veuillez saisir Supprimer"
    },
    "disqualifyImmediately": "Disqualifier immédiatement",
    "disqualifyAfterSubmit": "Disqualifier après soumission",
    "generalSettings": "Réglages Général",
    "advancedSettings": "Réglages avancés",
    "customFieldName": "Nom de l'entreprise",
    "customFieldNameTooltip": "Ce nom d'entreprise est unique par .",
    "uniqueKey": "Clé unique",
    "uniqueKeyTooltip": "Cette clé est unique par l'entreprise.",
    "selectContactAssociation": "Sélectionner la relation avec des contacts",
    "associations": "Associations",
    "createNewAssociation": "Créer une nouvelle relation",
    "selectAnAssociation": "Sélectionner une relation",
    "loadingAssociations": "Chargement des relations en cours…",
    "unknownAssociation": "Relation inconnue",
    "manyToMany": "Plusieurs à plusieurs",
    "failedToLoadAssociations": "Échec du chargement des relations",
    "noAssociationsFound": "Aucune relation trouvée",
    "keepThisField": "Garder ce champ",
    "association": "Relation",
    "customObject": "Objet personnalisé",
    "customObjects": "Objets personnalisés",
    "object": "Objet",
    "editAssociation": "Modifier la relation {objectName}",
    "editAssociationButton": "{edit} {association} {objectName}",
    "fields": "Domaines",
    "primaryFieldWarning": "{fieldName} est un champ principal pour {objectSingular} et est obligatoire pour créer une mise à jour d'un {objectSingular}.",
    "primaryFieldTitle": "{fieldName} est obligatoire pour créer ou mettre à jour l'enregistrement {objectSingular}.",
    "removeAllFields": "Supprimer tous les champs {objectSingular}",
    "customObjectsFallback": "Objets personnalisés",
    "noneAssociation": "Aucun",
    "noneAssociationDescription": "Aucune relation avec des contacts (aucun champ Contact présent)",
    "survey": {
      "layoutType": "Type de sondage",
      "oneQuestionPerPage": "Une question à la fois",
      "allQuestionsOnePage": "Plusieurs à la fois"
    },
    "quizQuestions": "Demande de quiz",
    "choiceElements": "Sélections des composants",
    "otherElements": "Autres composants",
    "listEditor": {
      "prefillValueHeader": "Pré-remplir la Valeur",
      "labelPlaceholder": "Étiquette",
      "valuePlaceholder": "Valeur",
      "optionRequiredError": "Le Champ d'options est obligatoire"
    },
    "field": "Champ",
    "scoreEditor": {
      "addFieldPlaceholder": "Ajouter un Champ",
      "fieldLabel": "Champ",
      "numberLabel": "nombre"
    },
    "fileUploadEditor": {
      "fileTypes": "Type de Fichier",
      "all": "Tout",
      "pdf": "PDF",
      "docxDoc": "D'UTILISATEUR",
      "png": "PNG",
      "gif": "GIF",
      "jpgJpeg": "JPG/JPG",
      "xlsCsv": "CSV"
    },
    "ok": "OK",
    "select": "Sélectionner",
    "allowMultipleFiles": "Plusieurs fichiers actifs",
    "maxFileLimit": "Limite Max de Fichier",
    "privacyPolicy": "Confidentialité",
    "termsOfService": "Terme de service",
    "typeAnOption": "Veuillez taper une option",
    "verifyPhone": "Vérifier le téléphone",
    "billingFrequency": "Fréquence de facturation",
    "otherAmount": "Autre montant",
    "exampleUrlPlaceholder": "https://www.example.com",
    "checkboxStyles": {
      "standardAlt": "Style standard de case à cocher",
      "bubbleAlt": "Style de case à cocher à bulles"
    },
    "previewIcons": {
      "exportAlt": "Icône d’exportation",
      "shipmentAlt": "Icône d’expédition",
      "resultAlt": "Icône de la page de résultats"
    },
    "examples": {
      "sampleUrl": "https://example.com"
    },
    "fillValuesPlaceholder": "Remplissez les valeurs",
    "showing": "Affichage",
    "of": "de",
    "enterCouponCode": "Entrez le code promo",
    "apply": "Applique",
    "paymentWillBeProcessed": "Le paiement sera traité dès que vous passerez à l'étape suivante",
    "paymentWillBeProcessedNextSlide": "Le paiement sera traité dès que l'utilisateur passera à la diapositive suivante",
    "showThisAlertToUsers": "Affichez cette alerte aux utilisateurs",
    "sixteenDigitCardNumber": "Numéro de carte à 16 chiffres",
    "mmYy": "MM / AA",
    "cvc": "CVC",
    "pleaseFillRequiredFields": "Veuillez remplir tous les champs obligatoires !",
    "verifyEmail": "Vérifiez le courriel",
    "verifyPhone": "Vérifier le téléphone"
  },
  "fields": {
    "quizQuestions": {
      "singleChoice": "Sélection individuelle",
      "multipleChoice": "Sélection multiples de choix",
      "yesNo": "Oui / Non",
      "shortAnswer": "Réponse à la Cour",
      "longAnswer": "Longueur de la réponse",
      "number": "nombre",
      "singleDropdown": "Liste individuelle",
      "multiDropdown": "Plusieurs Liste déroulante"
    },
    "personal": {
      "fullName": "Nom Plein",
      "firstName": "Prénom",
      "lastName": "Dernière nom",
      "dateOfBirth": "Date de naissance",
      "phone": "Téléphone",
      "email": "Gmail"
    },
    "submit": {
      "button": "Bouton"
    },
    "integration": {
      "sellProducts": "Vendre des produits",
      "collectPayment": "Percevoir le Paiement"
    },
    "address": {
      "address": "Adresse",
      "streetAddress": "Adresse de la rue",
      "city": "Ville",
      "state": "État",
      "country": "Pays",
      "postalCode": "Code postal",
      "organization": "Groupe",
      "website": "Site Web",
      "websitePlaceholder": "Placez l'URL du site Web ici."
    },
    "text": {
      "singleLine": "Ligne individuelle",
      "multiLine": "Plusieurs Ligne",
      "textBoxList": "Liste Carré du texte"
    },
    "choiceElements": {
      "singleDropdown": "Liste individuelle",
      "multiDropdown": "Plusieurs Liste déroulante",
      "checkbox": "Case à cocher",
      "radio": "Radio"
    },
    "customized": {
      "text" : "Cliquez pour modifier ce texte",
      "html": "HTML",
      "htmlPlaceholder": "Placez le code HTML Personnalisé ici.",
      "captcha": "Majuscule",
      "source": "Source",
      "termsAndConditions": "T et C",
      "termsAndConditionsPlaceholder": "J'accepte les conditions générales via l'entreprise. via l'envoi de mon",
      "score": "Pointage"
    },
    "other": {
      "image": "Image",
      "fileUpload": "Téléverser du Fichier",
      "monetary": "Monétaire",
      "number": "nombre",
      "datePicker": "Sélecteur de Date",
      "signature": "Signataire"
    },
    "customstyle": "Style",
    "standard": "Norme",
    "bubble": "Bulle"
  },
  "survey": {
    "typeOfBuilder": "Enquête",
    "survyeStyle": "Style d'enquête",
    "surveyName": "Nom de l'enquête",
    "surveyElement": "Élément de l'enquête",
    "addSurveyElement": "Ajouter un élément d'enquête",
    "cloneSlide": "Dupliquer la diapositive",
    "unsavedAlertMessage": "L'enquête comporte un travail non enregistré. Voulez-vous vraiment quitter et perdre tout travail non enregistré?",
    "thirdPartyScriptAlertMessage": "Les scripts tiers placés dans le bloc HTML peuvent offrir des fonctionnalités puissantes, mais ils présentent également des risques pour la confidentialité, la sécurité, les performances et le comportement de la page. Par conséquent, nous vous recommandons de vérifier le contenu de ce script avant de l'enregistrer dans l'enquête.",
    "integrateHeader": "Intégrer le sondage",
    "integrateSubHeader": "Utilisez les options suivantes pour intégrer votre enquête personnalisée dans votre site Web.",
    "integrateCopyLinkMessage": "Copiez le lien ci-dessous et partagez-la facilement à l'endroit souhaité.",
    "onSurveySubmission": "Lors de la soumission de l'enquête",
    "surveySettings": "Paramètres de l'enquête",
    "oneQuestionAtTime": "Une question à la fois",
    "backButton": "Bouton Retour",
    "backButtonTooltipMessage": "Le bouton Retour aidera les utilisateurs à revenir à la diapositive précédente",
    "disableAutoNavigation": "Désactiver la navigation automatique",
    "disableAutoNavigationTooltipMessage": "Naviguez automatiquement vers les .",
    "autoNavigation": "Navigation Auto",
    "autoNavigationTooltipMessage": "Naviguez automatiquement vers les .",
    "progressBar": "Barre de progression",
    "progressBarTooltipMessage": "Désactiver cette option supprimera la barre de progression du sondage",
    "disableAnimation": "Désactiver l'animation",
    "disableAnimationTooltipMessage": "Si vous activez cette option, l'animation de transition entre diapositives sera désactivée.",
    "scrollToTop": "Faire défiler jusqu'en haut",
    "scrollToTopTooltipMessage": "Si vous activez cette fonction, l'enquête défilera vers le haut de la diapositive suivante.",
    "submitSurvey": "Soumettre le sondage",
    "disqualifyImmediately": "Disqualifier immédiatement",
    "disqualifyAfterSubmit": "Disqualifier après soumission",
    "disqualifyAfterSubmitLowerCase": "Disqualifier après soumission",
    "select": "Sélectionner",
    "footerHTML": "HTML de pied de page",
    "footerHTMLMessage": "Vous pouvez écrire des feuilles de style personnalisées (en utilisant la balise de style) et du HTML dans la même case.",
    "editFooter": "Modifier le pied de page",
    "disqualifySettings": "Paramètres de disqualification",
    "disqualifyImmediately": "Disqualifier immédiatement",
    "disqualifyAfterSubmit": "Disqualifier après soumission",
    "disqualifyImmediatelyLabel": "Immédiatement",
    "disqualifyAfterSubmitLabel": "Après la soumission",
    "slideConflictAlertMessage": "Cette diapositive contient plusieurs questions qui ont une logique définie. Cela peut entraîner des comportements non intentionnels.",
    "addSlide": "Ajouter une diapositive",
    "settings": "Paramètres",
    "delete": "Supprimer",
    "slideDeleteAlertMessage": "Voulez-vous vraiment supprimer cette diapositive?",
    "slideDeleteBetweenAlertMessage": "Cela réorganisera les autres diapositives. Voulez-vous vraiment supprimer cette diapositive?",
    "slideLabel": "Diapositive {n}",
    "slideName": "Nom de la diapositive",
    "slidePosition": "Position de la diapositive",
    "jumpTo": "Aller à",
    "jumpToSubText": "Accéder à une diapositive spécifique",
    "enableTimezoneSurvey": "Si vous activez cette option, l'information de fuseau horaire de la personne qui soumet l'enquête sera capturée.",
    "footer": {
      "footer": "Pied de page",
      "enableNewFooter": "Activer le nouveau pied de page",
      "stickToSurvey": " Joindre à l'enquête",
      "backgroundFill": "Remplissage d’arrière-plan",
      "footerHeight": "Hauteur du pied de page",
      "enableProgressBar": "Activer la barre de progression",
      "buttons": "Boutons",
      "button": "Bouton",
      "buttonType": "Type de bouton",
      "fillNext": "Remplir (suivant)",
      "fillPrevious": "Remplir (précédent)",
      "fillSubmit": "Remplissage (Soumettre)",
      "textColor": "Texte du bouton",
      "position": "Position",
      "previousText": "Précédent (texte)",
      "nextText": "Suivant (texte)",
      "submitText": "Soumettre (texte)",
      "fillComplete": "Remplissage terminé",
      "fillInactive": "Remplissage inactif",
      "footerType": "Type de pied de page",
      "stickToCard": "Joindre à la carte",
      "stickToPage": "Joindre à la page",
      "stepTextColor": "Étape de la couleur du corps",
      "progressBarFill": "Remplir de la Barre de progression",
      "progressBarInactive": "Barre de progression Inactif",
      "arrowFill": "Remplir de la Flèche",
      "submitColorMobile": "Soumettre (Couleur)",
      "arrowFillColor": "Couleur de la couleur",
      "buttonTypes": {
        "textAndArrow": "Texte & Flèche",
        "onlyText": "Texte seulement",
        "onlyArrow": "Flèche uniquement"
      },
      "positions": {
        "leftAndRight": "Gauche et droite"
      },
      "placeholders": {
        "prev": "Précédent",
        "next": "Suivant",
        "submit": "Soumettre"
      }
    },
    "surveyNotfication": "Notification d’enquête",
    "style": {
      "surveyPadding": "Remplissage de l'enquête"
    },
    "integratePopup": {
      "shareOrEmbed": "Intégrer ou partager une enquête",
      "share": {
        "openFormLink": "Ouvert le Lien de Sondage"
      },
      "email": {
        "emailSubheader": "Créez un courriel vide et intégration de votre Sondage, sortant un modèle et l'intégration immédiatement."
      }
    },
    "autoResponderSubheader": "Envoyez un courriel automatisé à la personne qui soumet l'enquête (le courriel comprend une copie des renseignements saisis dans l'enquête).",
    "switchToOneQuestionAtTimeOn": "L'activation d' « Une Question à une Date» bloque votre logique conditionnelle actuelle.",
    "switchToOneQuestionAtTimeOff": "Désactiver « Une Question à une Date» a un impact sur votre logique conditionnelle Config",
    "switchToOneQuestionAtTimeOnWarning": "Certains conditions ne fonctionneront plus comme Date.",
    "switchToOneQuestionAtTimeOffWarning": " Toutes les conditions conçue pour le Débit sur des questions cesseront de fonctionner comme prévu.",
    "createContactOnPartialSubmissionSubText": "Crée un contact lorsqu'un utilisateur clique sur « Suivant » sur n'importe quelle diapositive — même s'il ne termine pas le sondage.",
    "dragDrop": {
      "imageLabel": "Image {n}",
      "htmlLabel": "HTML {n}",
      "defaultFolderName": "Sondage | {name}",
      "defaultTermsHtml": "<p style=\"text-align: center\"><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Politique de confidentialité</a> | <a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Conditions d'utilisation</a></p>",
      "smsConsent": "Je consens à recevoir des notifications par SMS, des alertes et des communications marketing occasionnelles de la part de l’entreprise. La fréquence des messages varie. Les frais de message et de données peuvent s'appliquer. Envoyez HELP au (XXX) XXX-XXXX pour obtenir de l’assistance. Vous pouvez répondre STOP pour vous désabonner à tout moment."
    }
  },
  "form": {
    "typeOfBuilder": "Formulaire",
    "formStyle": "Style de formulaire",
    "formElement": "Élément de formulaire",
    "addFormElement": "Ajouter un élément de formulaire",
    "addConditionalLogic": "Ajouter une logique conditionnelle",
    "openConditionalLogic": "Ouvrir la logique conditionnelle",
    "inlineForm": "Formulaire en ligne",
    "formName": "Nom du formulaire",
    "fullScreenMode": "Mode plein écran",
    "fullScreenModetooltip": "Si vous activez cette fonction, le formulaire s'étendra sur toute la largeur de son conteneur, s'étirant jusqu'au bord de la zone d'intégration tout en adhérant à la largeur du formulaire.",
    "enableTimezoneForm": "Si vous activez cette option, l'information de fuseau horaire de la personne qui soumet le formulaire sera capturée.",
    "formSettings": "Paramètres du formulaire",
    "unsavedAlertMessage": "Le formulaire comporte un travail non enregistré. Voulez-vous vraiment quitter et perdre tout travail non enregistré?",
    "thirdPartyScriptAlertMessage": "Les scripts tiers placés dans le bloc HTML peuvent offrir des fonctionnalités puissantes, mais ils présentent également des risques pour la confidentialité, la sécurité, les performances et le comportement de la page. Par conséquent, nous vous recommandons de vérifier le contenu de ce script avant de l'enregistrer dans le formulaire.",
    "onFormSubmission": "Lors de la soumission du formulaire",
    "integrateForm": "Intégrer le formulaire",
    "embedlayoutType": "Embarquer le Type de Mise en page",
    "embedlayoutTypeSubMessage": "Sélectionnez une mise en page à intégrer dans un entonnoir ou un site Web externe.",
    "triggerType": "Type de déclencheur",
    "showOnScrolling": "Afficher lors du défilement",
    "showAfter": "Afficher après",
    "seconds": "secondes",
    "alwaysShow": "Toujours afficher",
    "activationOptions": "Options d'activation",
    "activateOn": "Activer lors de",
    "visit": "visite",
    "alwaysActivated": "Toujours activé",
    "deactivationOptions": "Options de désactivation",
    "deactivateAfterShowing": "Désactiver après affichage",
    "times": "fois",
    "deactiveOnceLeadCollected": "Désactiver une fois le client potentiel collecté",
    "neverDeactivate": "Ne jamais désactiver",
    "copyEmbedCode": "Copier le code d'intégration",
    "copyFormLink": "Copier le lien du formulaire",
    "openFormLink": "Ouvrir le lien du formulaire",
    "inline": "Intégré",
    "inlineDescription": "Un formulaire intégré apparaît avec le contenu de la page en tant qu'élément d'origine. Il ne se superpose pas et ne peut pas être fermé ou réduit au minimum.",
    "inlineHoverDescription": "Un formulaire intégré apparaît avec le contenu de la page en tant qu'élément d'origine. Il ne se superpose pas et ne peut pas être fermé ou réduit au minimum.",
    "popup": "Fenêtre contextuelle",
    "popupDescription": "Une fenêtre contextuelle affiche le formulaire sous la forme d'une superposition à l'intérieur d'une case lumineuse. Cette dernière ne peut pas être réduite, mais peut être fermée.",
    "popupHoverDescription": "Une fenêtre contextuelle affiche le formulaire sous la forme d'une superposition à l'intérieur d'une case lumineuse. Cette dernière ne peut pas être réduite, mais peut être fermée.",
    "politeSlideIn": "Formulaire coulissant",
    "politeSlideInDescription": "Un formulaire coulissant apparaît en bas de l'écran et disparaît une fois fermé.",
    "politeSlideInHoverDescription": "Apparaît en bas de l'écran et disparaît une fois fermé.",
    "stickySidebar": "Barre latérale épinglée",
    "stickySidebarDescription": "Une barre latérale épinglée apparaît sur le côté de l'écran et peut être réduite à un onglet épinglé sur le côté de la fenêtre.",
    "stickySidebarHoverDescription": "Apparaît sur le côté de l'écran et peut être réduite à un onglet épinglé sur le côté de la fenêtre.",
    "allowMinimize": "Permettre de réduire",
    "conditonalLogic": {
      "conditions": "Conditions",
      "noExistingCondition": "Aucune condition existante pour le moment",
      "freeRoamMessage": "Vous êtes libre de vous déplacer sans règles, du moins pour l'instant.",
      "addNewCondition": "Ajouter une nouvelle condition",
      "redirectToUrl": "Rediriger vers une URL",
      "displayCustomMessage": "Afficher un message personnalisé",
      "disqualifyLead": "Disqualifier le prospect",
      "showHideFields": "Afficher/Masquer les champs",
      "jumpTo": "Accéder à",
      "redirectToUrlSubText": "Rediriger la soumission d'utilisateurs",
      "displayCustomMessageSubText": "Afficher les messages en fonction des entrées de l'utilisateur",
      "disqualifyLeadSubText": "Filtre les entrées dans des conditions spécifiques",
      "showHideFieldsSubText": "Modifier la Visibilité",
      "openBelowUrl": "Ouvrir l'URL ci-dessous",
      "showCustomMessage": "Afficher un message personnalisé",
      "alertConditionDelete": "Voulez-vous vraiment supprimer cette condition?",
      "deleteCondition": "Supprimer la condition",
      "conditionExecutedMessage": "Les conditions seront exécutées de haut en bas.",
      "allOperationOptions": {
        "isEqualTo": "Est égal à",
        "isNotEqualTo": "N'est pas égal à",
        "contains": "Contient",
        "doesNotContain": "Ne contient pas",
        "startsWith": "Commence par",
        "endsWith": "Se termine par",
        "isEmpty": "Est vide",
        "isFilled": "Est rempli",
        "before": "Avant",
        "after": "Après",
        "greaterThan": "Supérieur à",
        "lessThan": "Inférieur à",
        "between": "Entre",
        "isChecked": "Est vérifié",
        "isNotChecked": "N’est pas vérifié"
      },
      "logic": {
        "if": "Si",
        "then": "Puis",
        "and": "Et",
        "or": "Ou"
      },
      "phoneAlertMessage": "Pour rechercher des numéros de téléphone avec un code de pays, vous devez inclure explicitement le symbole « + » dans votre requête de recherche.",
      "deleteAlertMessage": "Voulez-vous vraiment supprimer ce champ? La condition associée à ce champ sera également supprimée.",
      "deleteField": "Supprimer le champ",
      "jumpToDescription": "Accédez à une diapositive spécifique lorsque les conditions sont remplies",
      "cycleError": "Impossible d’enregistrer. Cycle détecté entre {a} et {b}",
      "jumpToSlide": "Accéder à une diapositive",
      "submitSurvey": "Soumettre un sondage",
      "pageTitle": "P{index} - {title}",
      "selectSlideToJumpTo": "Sélectionnez la diapositive à partir de laquelle vous souhaitez passer",
      "selectedSlide": "Diapositive sélectionnée",
      "typeValueHere": "Veuillez saisir une valeur ici",
      "field": "Champ",
      "slide": "Diapositive",
      "selectFieldOrSlide": "Sélectionner le champ ou la diapositive",
      "selectFieldState": "Sélectionner l'état du champ",
      "selectField": "Sélectionnez le champ",
      "selectOption": "Sélectionner l’option",
      "jumpToTarget": "Aller à",
      "jumpToQuestion": "Passer à la question",
      "chooseQuestion": "Sélectionner une question",
      "includeStart": "Inclure le début",
      "includeEnd": "Inclure la fin",
      "includeValue": "Inclure {value}",
      "hideField": "Masquer le champ",
      "hideFields": "Masquer les champs",
      "showField": "Afficher le champ",
      "showFields": "Afficher les champs",
      "additionalRulesPrefix": "... et",
      "additionalRulesSuffix": "autres règles {ifLabel}...",
      "shownTargetsWithMore": "{shown}, +{count} de plus",
      "noConditionsAlt": "Aucune condition pour le moment",
      "outcomeLabels": {
        "show": "Afficher",
        "jumpTo": "Aller à"
      }
    },
    "minimizedTitlePlaceholder": "Titre réduit",
    "dragYourElementFromLeft": "Faites glisser vos éléments ici à partir de la gauche.",
    "formNotification": "Notification de formulaire",
    "style": {
      "formPadding": "Remplissage de formulaire"
    },
    "integratePopup": {
      "shareOrEmbed": "Intégrer ou Partager le Formulaire",
      "share": {
        "openFormLink": "Ouvert le Lien du Formulaire"
      },
      "email": {
        "emailSubheader": "Créez un courriel vide et equerrez votre formulaire, ou ."
      }
    },
    "choosePosition": "Sélectionner du statut"
  },
  "quiz": {
    "quizElement": "Élément de quiz",
    "quizNotification": "Notification de questionnaire",
    "viewAndCustomise": "Voir et personnaliser",
    "categoryAndScore": "Catégorie et score",
    "provideFeedback": "Fournir des commentaires",
    "addQuizElement": "Ajouter un élément de quiz",
    "typeOfBuilder": "Questionnaire",
    "addQuestions": "Ajouter des questions",
    "dragAndDropQuestion": "Traîner et supprimer un élément de Question ici.",
    "addNewPage": "Ajouter une nouvelle Page",
    "editTemplate": "Modifier le Modèle",
    "clonePage": "Dupliquer la page",
    "category": {
      "category": "Catégorie",
      "watchVideo": "Voir cette vidéo pour en Page plus.",
      "useCategoryWhen": "Utiliser des catégories Quand",
      "manageCategories": "Gérer les Catégories",
      "howItWorks": "Comment fonctionne ce travail?",
      "howItWorks2": "Comment fonctionne ce travail",
      "addCategoryMessage": "Ajouter une nouvelle catégorie",
      "assignCategoryMessage": "Attribuer une catégorie à tous les options",
      "editResultsMessage": "Afficher le score in la Page des résultats",
      "addCategory": "Ajouter une Catégorie",
      "deleteCategoryAlertMessage": "La Supprimer d'une catégorie entraînera le retour de cette catégorie in toutes les Options",
      "editOrAddNewCategories": "Vous pouvez modifier ou inclure de nouveaux catégories",
      "toEvaluateTheResponder": "Pour Comparer le Répondeur en fonction de plusieurs facteurs",
      "showMultipleCategoryScore": "Afficher plusieurs catégories in la Page des résultats",
      "displayVaryingContent": "Affichage de la Page de résultats en fonction de l'affichage du niveau de score",
      "theOptionFieldIsRequired": "Le champ d'option est obligatoire",
      "addManage": "Ajouter / Gérer",
      "enterCategoryPlaceholder": "Saisissez le nom de la catégorie",
      "carouselAlt": "Diapositive d’aperçu de la Catégorie"
    },
    "quizSettings": "Paramètres du quiz",
    "onQuizSubmission": "Lors de la soumission du questionnaire",
    "settings": "Paramètres",
    "deletePage": "Supprimer la page",
    "quizResult": {
      "resultTemplate": "Modèle de résultat",
      "quizResultAlertMessage": "La page de résultats choisie s'affichera une fois le questionnaire terminé."
    },
    "autoResponderSubheader": "Envoyez un courriel automatisé à la personne qui soumet le questionnaire (le courriel comprend une copie des renseignements qu’elle a saisis dans le questionnaire).",
    "integrateHeader": "Intégrer le quiz",
    "integrateSubHeader": "Utilisez les options suivantes pour intégrer votre questionnaire personnalisé dans votre site Web.",
    "integrateCopyLinkMessage": "Copiez le lien ci-dessous et partagez-le facilement à l'endroit souhaité.",
    "pageLabel": "Page {n}",
    "pageName": "Nom de la page",
    "pagePosition": "Position de la page",
    "createContactOnPartialSubmissionSubText": "Crée un contact lorsqu'un utilisateur clique sur « Suivant » sur n'importe quelle diapositive — même s'il ne termine pas le questionnaire.",
    "integratePopup": {
      "shareOrEmbed": "Intégrer ou partager le questionnaire",
      "share": {
        "openFormLink": "Ouvert le Lien du quiz"
      },
      "email": {
        "emailSubheader": "Créez un courriel vide et intégrer votre quiz."
      }
    }
  }
}
